var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/Video/Video.jinja"] = require( "front/components/Video/Video.jinja" );
dependencies["front/components/Frame/Frame.jinja"] = require( "front/components/Frame/Frame.jinja" );
dependencies["front/components/Contacts/Contacts.jinja"] = require( "front/components/Contacts/Contacts.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ContactsPage.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/Video/Video.jinja", false, "ContactsPage.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("Video", t_1);
output += "<div class=\"ContactsPage\">\n    <div class=\"Hero\">\n        ";
env.getTemplate("front/components/Frame/Frame.jinja", false, "ContactsPage.jinja", function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
t_4.render(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
output += t_5
output += "\n        ";
output += runtime.suppressValue((lineno = 5, colno = 25, runtime.callWrap(runtime.memberLookup((t_1),"Video"), "Video[\"Video\"]", context, ["contacts_v2",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page")),"img")),"main"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"is_tablet"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
output += "\n        ";
env.getTemplate("front/components/Contacts/Contacts.jinja", false, "ContactsPage.jinja", function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["ContactsPage.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/ContactsPage/ContactsPage.jinja
// module id = 82
// module chunks = 0